import { CardType } from './card-type.enum';
import { Progress } from './progress';

export class StatusCard {
    name: string;
    cardType: CardType;
    progress: Progress;
    clLimit: number;
    disableCTA: boolean;
    constructor(name: string, cardType: CardType, progress = null, clLimit = null, disableCTA = false) {
        this.name = name;
        this.cardType = cardType;
        this.progress = progress;
        this.clLimit = clLimit;
        this.disableCTA = disableCTA;
    }
}
